import { QuestionType } from 'typescript/enums/QuestionType.d';

import { type QuestionComboLock } from 'api/types/ChapterContent/QuestionComboLock';
import { type RawQuestionComboLock } from 'api/types/ChapterContent/QuestionComboLock/RawQuestionComboLock';

export const parseComboLock = (data: RawQuestionComboLock): Omit<QuestionComboLock, 'image'> => {
  return {
    amountOfDials: data.amountOfDials,
    correctAnswer: Number(data.correctAnswer),
    correctAnswerText: data.correctAnswerText,
    id: data.UPID,
    incorrectAnswerText: data.incorrectAnswerText,
    pageNumber: data.pageNumber,
    question: data.question,
    title: data.question,
    type: QuestionType.QuestionComboLock,
  };
};
